import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-committee26',
  templateUrl: './program-committee.component.html',
  styleUrls: ['./program-committee.component.css']
})
export class ProgramCommitteeComponent26 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
